export default {
  FETCH_USERS: 'FETCH_USERS',
  FETCH_PAGINATED_USERS: 'FETCH_PAGINATED_USERS',
  FETCH_USER: 'FETCH_USER',
  FETCH_ROLES: 'FETCH_ROLES',
  SET_LOGIN_ERROR: 'SET_LOGIN_ERROR',
  UPDATE_USER: 'UPDATE_USER',
  DELETE_USER: 'DELETE_USER',
  SEND_PASSWORD_RESET: 'SEND_PASSWORD_RESET'
}
